/**
 * Overleg-voorbereiding als taakregel bovenaan Vandaag: "Vul je invulblok in voor MT-punt (ma 28 sep 10:08)".
 * Alleen zolang het invulblok van een komende sessie openstaat (vanaf het pakketmoment tot de start) en
 * alleen voor deelnemers — dat filtert de engine (/Api/overleg/invulblokken). Na indienen verdwijnt de regel.
 * Eigen component zodat Vandaag.jsx er maar één regel voor hoeft te dragen.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { overlegApi } from '../Overleg/overlegApi';
// Main heeft DagTaakRij (nog) niet: dezelfde rustige kleuren/maten lokaal.
const KLEUR = { tekst: '#1f2933', zacht: '#7b848e', achter: '#f2f4f6', primair: '#526075' };
const MAAT = { tekst: '0.9rem', klein: '0.74rem' };

export default function OverlegTaak() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let weg = false;
    const laad = () => overlegApi.invulblokken()
      .then((d) => { if (!weg) setItems(Array.isArray(d?.items) ? d.items : []); })
      .catch(() => { /* geen recht of engine even weg: geen regel is geen fout in beeld waard */ });
    laad();
    // Terug op het tabblad na indienen? Dan meteen weg.
    const opZicht = () => { if (!document.hidden) laad(); };
    document.addEventListener('visibilitychange', opZicht);
    return () => { weg = true; document.removeEventListener('visibilitychange', opZicht); };
  }, []);

  if (!items.length) return null;
  return (
    <Box sx={{ mb: 1 }}>
      {items.map((it) => (
        <Box key={it.sessie_id} role="link" tabIndex={0}
          onClick={() => navigate(it.link || `/overleg/sessie/${it.sessie_id}#invulblok`)}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(it.link); } }}
          sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.6, borderRadius: '8px', cursor: 'pointer', '&:hover, &:focus-visible': { backgroundColor: KLEUR.achter } }}>
          <EditNoteOutlinedIcon sx={{ fontSize: 20, color: KLEUR.primair, flexShrink: 0 }} />
          <Typography sx={{ flex: 1, minWidth: 0, fontSize: MAAT.tekst, color: KLEUR.tekst, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {it.titel}
          </Typography>
          <Typography sx={{ fontSize: MAAT.klein, color: KLEUR.zacht, flexShrink: 0 }}>twee minuten</Typography>
        </Box>
      ))}
    </Box>
  );
}
